import { Box, Card, CardContent, Stack } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';
import type {
  DrilldownHeaderProps,
  HeaderItems,
} from '@components/DrilldownHeader';
import {
  AdditionalInfo,
  HeaderContent,
  Item,
  ItemIcon,
  ItemTitle,
  ItemTitleWrapper,
  Subtitle,
  Title,
  TitleDiv,
  TitleWidth,
} from '@components/DrilldownHeader/DrilldownHeader.style';
import Icon from '@components/Icon/Icon';
import SelfReportedPill from '@components/SelfReportedPill';

import { useIsMobile } from '@hooks/useIsMobile';

import { MobileWrapper } from '@layouts/AppLayout/AppLayout.style';

import type { FhirResource } from '@models/fhir-resource';

export default function SharingDrilldownWrapper({
  loading = true,
  title = '',
  selfReported = false,
  items,
  subtitle,
  children,
}: DrilldownHeaderProps & {
  // loading?: boolean;
  selfReported?: boolean;
  // title?: string | null;
  resource: FhirResource | null | undefined;
  subtitle?: React.ReactNode | string[] | string | null;
  items?: HeaderItems[];
  children?: React.ReactNode;
}) {
  const isMobile = useIsMobile();

  const content = (
    <Stack spacing={2}>
      <TitleDiv>
        <HeaderContent>
          <TitleWidth>{isMobile ? null : <Title>{title}</Title>}</TitleWidth>
          {isMobile ? <Title>{title}</Title> : null}
          <Subtitle subtitleSize="15px">
            {subtitle instanceof Array &&
            subtitle.filter((text) => text).length > 0 ? (
              subtitle
                .filter((text) => text)
                .reduce((acc, curr) => `${acc} • ${curr}`)
            ) : typeof subtitle === 'string' ? (
              subtitle
            ) : (
              <div
                style={{
                  width: 'initial',
                  color: 'initial',
                  fontSize: 'initial',
                }}
              >
                {subtitle}
              </div>
            )}
          </Subtitle>

          {items instanceof Array && items.length > 0 ? (
            <AdditionalInfo>
              {items
                .filter(({ title }) => title)
                .map(({ title, iconName, iconColor }, index) => (
                  <Item key={`drilldown-header-item-${title}-${index}`}>
                    <ItemTitleWrapper>
                      {iconName ? (
                        <ItemIcon>
                          <Icon
                            color={iconColor ?? 'warning.main'}
                            name={iconName}
                            type="fas"
                          />
                        </ItemIcon>
                      ) : null}
                      <ItemTitle>{title ?? null}</ItemTitle>
                    </ItemTitleWrapper>
                  </Item>
                ))}
            </AdditionalInfo>
          ) : null}

          <SelfReportedPill header value={selfReported} />
        </HeaderContent>
      </TitleDiv>
      {children ? (
        <Box sx={{ width: '100%' }}>
          <Card>
            <CardContent>{children}</CardContent>
          </Card>
        </Box>
      ) : null}
    </Stack>
  );

  return (
    <>
      {isMobile ? (
        <MobileWrapper>
          <ContentLoader loading={loading}>{content}</ContentLoader>
        </MobileWrapper>
      ) : (
        <ContentLoader loading={loading}>{content}</ContentLoader>
      )}
    </>
  );
}
